import React, { Component } from "react";

import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from "@coreui/react";
import { EllipsisVertical, EyeIcon } from "lucide-react";

import { ContentCard } from "../ContentCard";
import Interface from "../Interface";
import Lsc from "../LessonsSlideChose/lsc";
import ModalActivity from "../Modal/ModalActivity";

import "./css/contentItemActivity.css";

class contentItemActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleBox: false,
      // activity: false,
      modal: false,
      show: true,
      iframe: false
    };
  }

  toggleBox = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      toggleBox: !this.state.toggleBox
    });
  };

  openSlideVisualisation = () => {
    this.setState(
      {
        // item: this.props.content
      },
      () => {
        this.toggleModal();
      }
    );
  };

  handleViewAction = content => {
    const url = window.location.href.split("/");
    const title = content.name.replace(/ /g, "%18");
    window.open(
      `${url[0]}//${url[2]}/content/view/${content.id}?title=${title}`
    );
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      modal: !this.state.modal
    });
  };

  selectItem = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ show: !this.state.show });
    this.getSelected(this.props.content);
  };

  getSelected = select => {
    this.props.getSelected(select);
  };

  send = () => {
    this.toggleModal();
    this.props.send();
  };

  openIframe = () => {
    this.setState({ iframe: true });
  };

  formatSeries = content => {
    if (!content.series || content.series.length === 0) return "";
    if (content.series.length === 1) return `${content.serie_name}`;
    if (content.series.length === 2) {
      return `${content.series[0].name} e ${content.series[1].name}`;
    }

    return (
      <div className="d-flex align-items-center">
        {`${content.series[0].name}, ${content.series[1].name} e `}
        <u
          title={content.series.map(serie => serie.name).join(", ")}
          className="ml-1"
        >
          mais...
        </u>
      </div>
    );
  };

  checkIfContentIsNew = content => {
    const today = new Date();
    const contentDate = new Date(content.updated_at);
    const diffTime = Math.abs(today - contentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  render() {
    const { content } = this.props;

    return (
      <>
        {this.state.iframe && (
          <Interface
            show
            title={content.name}
            onClose={() => this.setState({ iframe: false })}
            aula={content.id}
            currentRoute={this.props.currentRoute}
          />
        )}
        <div
          className="contentArea mt-3 w-100"
          onClick={!this.props.activity ? this.openIframe : this.selectItem}
        >
          <ContentCard.Root height="235px">
            <ContentCard.Banner
              content={content}
              fallbackColor={this.props.type.color}
              fallbackIcon={this.props.type.icon}
              badge={this.checkIfContentIsNew(content) && "Novo"}
              image={content.image}
            />
            <ContentCard.Main bgColor={`${this.state.show ? "" : "#d6ebff"}`}>
              <ContentCard.Header
                title={content.name}
                titleLink={`/content/view/${content.id}?title=${content.name}`}
              >
                <ContentCard.Item>
                  <small className="text-muted">
                    {this.formatSeries(content)} • {content.discipline_name}
                    {content.ability_code && ` • (${content.ability_code})`}
                  </small>
                </ContentCard.Item>
              </ContentCard.Header>
              <ContentCard.Body></ContentCard.Body>
            </ContentCard.Main>
          </ContentCard.Root>
          <CDropdown className="context">
            <CDropdownToggle
              caret={false}
              className="contextToggle rounded-circle btn-sm p-2"
            >
              <EllipsisVertical size={16} />
            </CDropdownToggle>
            <CDropdownMenu placement="top-end">
              <CDropdownItem
                className="text-dark"
                onClick={() => {
                  this.handleViewAction(content);
                }}
              >
                <EyeIcon size={18} className="mr-2" />
                Visualizar
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </div>
        {this.props.activity ? (
          <ModalActivity
            toggleModal={this.toggleModal}
            modalState={this.state.modal}
            title="Selecione os slides"
            className=" educandus modalActivity"
            backdrop="static"
            size="lg"
            noFooter
          >
            <Lsc
              content={this.props.content}
              getSelected={this.getSelected}
              send={this.send}
            />
          </ModalActivity>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default contentItemActivity;
